import doSetNotificationsAsReaded from '@/api/doSetNotificationsAsReaded';
import { useMutation } from '@tanstack/react-query';

function useMutateNotifications() {
  const mutateNotificationsAsReaded = useMutation({
    mutationFn: doSetNotificationsAsReaded,
    mutationKey: ['notifications/set-notifications-as-readed'],
  });

  return {
    mutateNotificationsAsReaded,
  };
}

export { useMutateNotifications };
